module.exports = "/static/assets/79cdb34da9e414fed91fcd376d98b259.gif";